/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigurationHealthResponse,
  HttpValidationProblemDetails,
  ProblemDetails,
  ReportGeneratorRequest,
  Stream,
  UndercarriageAllInspectionsResponse,
  UndercarriageFleetSnapshotResponse,
  UndercarriageFleetSummaryResponse,
  UndercarriageReportDataResponse,
  YardInventoryResponse,
} from '../models/index';
import {
    ConfigurationHealthResponseFromJSON,
    ConfigurationHealthResponseToJSON,
    HttpValidationProblemDetailsFromJSON,
    HttpValidationProblemDetailsToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ReportGeneratorRequestFromJSON,
    ReportGeneratorRequestToJSON,
    StreamFromJSON,
    StreamToJSON,
    UndercarriageAllInspectionsResponseFromJSON,
    UndercarriageAllInspectionsResponseToJSON,
    UndercarriageFleetSnapshotResponseFromJSON,
    UndercarriageFleetSnapshotResponseToJSON,
    UndercarriageFleetSummaryResponseFromJSON,
    UndercarriageFleetSummaryResponseToJSON,
    UndercarriageReportDataResponseFromJSON,
    UndercarriageReportDataResponseToJSON,
    YardInventoryResponseFromJSON,
    YardInventoryResponseToJSON,
} from '../models/index';

export interface GenerateReportRequest {
    reportGeneratorRequest: ReportGeneratorRequest;
}

export interface GetUndercarriageReportDataRequest {
    inspectionId: number;
}

/**
 * 
 */
export class ReportApi extends runtime.BaseAPI {

    /**
     */
    async generateReportRaw(requestParameters: GenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stream>> {
        if (requestParameters['reportGeneratorRequest'] == null) {
            throw new runtime.RequiredError(
                'reportGeneratorRequest',
                'Required parameter "reportGeneratorRequest" was null or undefined when calling generateReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/report/generate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportGeneratorRequestToJSON(requestParameters['reportGeneratorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamFromJSON(jsonValue));
    }

    /**
     */
    async generateReport(requestParameters: GenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stream> {
        const response = await this.generateReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllUndercarriageInspectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UndercarriageAllInspectionsResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/report/undercarriage/all-inspections`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UndercarriageAllInspectionsResponseFromJSON));
    }

    /**
     */
    async getAllUndercarriageInspections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UndercarriageAllInspectionsResponse>> {
        const response = await this.getAllUndercarriageInspectionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getConfigurationHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationHealthResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/report/configuration-health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationHealthResponseFromJSON(jsonValue));
    }

    /**
     */
    async getConfigurationHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationHealthResponse> {
        const response = await this.getConfigurationHealthRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUndercarriageFleetSnapshotRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UndercarriageFleetSnapshotResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/report/undercarriage/fleet-snapshot`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UndercarriageFleetSnapshotResponseFromJSON));
    }

    /**
     */
    async getUndercarriageFleetSnapshot(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UndercarriageFleetSnapshotResponse>> {
        const response = await this.getUndercarriageFleetSnapshotRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUndercarriageFleetSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UndercarriageFleetSummaryResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/report/undercarriage/fleet-summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UndercarriageFleetSummaryResponseFromJSON));
    }

    /**
     */
    async getUndercarriageFleetSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UndercarriageFleetSummaryResponse>> {
        const response = await this.getUndercarriageFleetSummaryRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUndercarriageReportDataRaw(requestParameters: GetUndercarriageReportDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UndercarriageReportDataResponse>> {
        if (requestParameters['inspectionId'] == null) {
            throw new runtime.RequiredError(
                'inspectionId',
                'Required parameter "inspectionId" was null or undefined when calling getUndercarriageReportData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/report/undercarriage/{inspectionId}/report-data`;
        urlPath = urlPath.replace(`{${"inspectionId"}}`, encodeURIComponent(String(requestParameters['inspectionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UndercarriageReportDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUndercarriageReportData(requestParameters: GetUndercarriageReportDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UndercarriageReportDataResponse> {
        const response = await this.getUndercarriageReportDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getYardInventoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YardInventoryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/report/yard-inventory`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => YardInventoryResponseFromJSON(jsonValue));
    }

    /**
     */
    async getYardInventory(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YardInventoryResponse> {
        const response = await this.getYardInventoryRaw(initOverrides);
        return await response.value();
    }

}
